var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('v-bottom-sheet',_vm._g(_vm._b({},'v-bottom-sheet',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('v-dialog',_vm._g(_vm._b({},'v-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }